import React from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/seo/Seo";
import { SeoLayout, Prose } from "@/components/site/SeoLayout";
import { BLOG, SERVICES } from "@/seo/content";
import { articleLd, breadcrumbLd } from "@/seo/schema";

export default function BlogPost() {
  const { slug } = useParams();
  const b = BLOG[slug];
  if (!b) return <Navigate to="/blog" replace />;

  const path = `/blog/${slug}`;
  const breadcrumb = [
    { name: "Home", path: "/" },
    { name: "Kennisbank", path: "/blog" },
    { name: b.h1, path },
  ];

  return (
    <>
      <Seo
        title={b.seoTitle}
        description={b.metaDesc}
        path={path}
        jsonLd={[articleLd(b.h1, b.metaDesc, path), breadcrumbLd(breadcrumb)]}
      />
      <SeoLayout breadcrumb={breadcrumb}>
        <article>
          <h1 className="font-heading text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl">{b.h1}</h1>
          <Prose intro={b.intro} sections={b.sections} />
        </article>

        {b.related?.length > 0 && (
          <section className="mt-12">
            <h2 className="font-heading text-2xl font-semibold text-slate-900">Gerelateerde diensten</h2>
            <div className="mt-6 grid gap-4 sm:grid-cols-2">
              {b.related.map((r) => (
                <Link
                  key={r}
                  to={`/${r}`}
                  className="group flex items-center justify-between rounded-2xl border border-slate-100 bg-white p-5 shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-md"
                >
                  <span className="font-medium text-slate-800">{SERVICES[r].label}</span>
                  <ArrowRight className="h-4 w-4 text-blue-600 transition-transform group-hover:translate-x-1" />
                </Link>
              ))}
            </div>
          </section>
        )}

        <div className="mt-10">
          <Link to="/blog" className="text-sm font-semibold text-blue-700 hover:underline">← Terug naar de kennisbank</Link>
        </div>
      </SeoLayout>
    </>
  );
}
